<template>
	<div class="videos">
		<div class="main-banner" :style="'background-image: url('+bannerList+');'">
			<div class="banner-title">
				<h2>工程案例</h2>
				<h3>case</h3>
			</div>
		</div>
		<div class="container">
			<div class="main">
				<div class="videoList">
					<ul>
						<li v-for="item in videoList" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
							<router-link :to="'/video-details?videoId='+item.id">
								<div>
									<img :src="item.pic">
                  <span class="iconfont">&#xe628;</span>
								</div>
								<h4 class="ellipsis">{{$AppLang == 'en' ? item.name_en : item.name}}</h4>
							</router-link>
						</li>
					</ul>
				</div>
				<el-pagination
					background layout="prev, pager, next"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:total="pageCount">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'videos',
	data() {
		return {
			videoList: [],
			bannerList: [],
			pageStart: 1,
			pageTotal: 6,
			pageCount: 50
		};
	},
	mounted() {
		this.videoPage();
		this.bannerApi();
	},
	methods: {
		handleSizeChange(val) {
			//console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			this.pageStart = val;
			this.videoPage();
			//console.log(`当前页: ${val}`);
		},
		videoClick(e){
			this.typeId = e;
			this.videoPage();
		},
		videoPage(){
			var that = this;
      var options={ live:false};
			//荣誉专利列表请求接口
			that.$api.post(
				'/video/websiteVideos',
				{
					pageStart: that.pageStart,
					pageTotal: that.pageTotal
				},
				function(res) {
					if(res.data.rtnCode == 200){
						var list = res.data.data;
            that.videoList = list.data;
            for(var i=0;i<that.videoList.length;i++){
              if(!that.videoList[i].pic){
                that.videoList[i].pic = require('../../assets/video-img.png');
              };
            };
            console.log(that.videoList);
						// that.pageCount = list.pageCount;
						if(that.pageStart * that.pageTotal < list.pageCount
							&& (that.pageStart + 1) * that.pageTotal > list.pageCount) 
							that.pageCount = (that.pageStart + 1) * that.pageTotal;
						else if(that.pageStart * that.pageTotal > list.pageCount) that.pageCount = that.pageCount;
						else that.pageCount = list.pageCount;
            that.$nextTick(function(){
            	var wow=new that.$wow.WOW(options).init();
            });
					}else{
						alert(res.data.msg);
					}

				}
			);
		},
		bannerApi(){
			var that = this;
			//banner请求接口
			that.$api.post(
				'banner/websiteBanners',
				{
					type: 2
				},
				function(res) {
					if(res.data.rtnCode == 200){
						var list = res.data.data;
						for(var i=0;i<list.length;i++){
							if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))){
								list[i].banner = list[i].phone_banner;
							}else{
								list[i].banner = list[i].pic;
							}
						}
						that.bannerList = list[0].banner;
					}else{
						alert(res.data.msg);
					}

				}
			);
		}
	},
  metaInfo: {
    title: '佛山鼎吉-工程案例', // set a title
    meta: [{ // set meta
      name: 'keywords',
      content: '鼎吉,鼎吉官网,陶瓷墙地砖拣选包装自动化设备,研发、设计、制造、安装为一体的高新技术型企业,佛山市鼎吉包装技术有限公司'
    },
    { // set meta
      name: 'description',
      content: '佛山市鼎吉包装技术有限公司成立于2008年,是一家集研发、设计、制造、安装为一体的高新技术型企业。专业致力于研发生产陶瓷墙地砖拣选包装自动化设备。公司遵循“以市场为导向、以研发为动力、以质量为核心竞争力”的发展宗旨服务建陶企业，为建陶产业的生产自动化和可持续发展做贡献。'
    }],
    link: [{ // set link
      rel: 'asstes',
      href: 'https://www.dinovor.com/'
    }]
  }
}
</script>

<style>
.videos{
	background-color: #fff;
}
.videos .main-banner{
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}
.videos .main{
  padding-bottom: 60px;
}
.videoList {
	margin-top: 60px;
	height: 676px;
}
.videoList ul{
	display: flex;
	justify-content: flex-start;
	flex-wrap: wrap;
}
.videoList ul li{
	overflow: hidden;
	width: 32%;
	position: relative;
	margin: 0 0.6666%;
	margin-bottom: 12px;
}
.videoList ul li a{
	text-decoration: none;
}
.videoList ul li div{
	height: 240px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.videoList ul li div::before{
  content: "";
  width: 90%;
  height: 90%;
  position: absolute;
  border: 1px solid #c1c1c1;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%) scale(1.2);
  z-index: 1;
  transition: all .3s ease;
}
.videoList ul li img{
	width: 100%;
  display: block;
  transition: all .3s ease;
}
.videoList ul li div:hover::before{
  transform: translate(-50%,-50%) scale(1);
}
.videoList ul li div:hover img{
  transform: scale(1.1);
}
.videoList ul li div span{
  color: #cfac70;
  font-size: 54px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%) scale(1.4);
  opacity: 0;
  transition: all .5s ease;
}
.videoList ul li div:hover span{
  opacity: 1;
  transform: translate(-50%,-50%) scale(1);
}
.videoList ul li h4{
  text-align: center;
	color: #333;
  margin-top: 20px;
}
.videos .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #333;
	color: rgba(255,255,255,.62);
}
@media (max-width: 992px){
	.videoList ul li{
		width: 48%;
		margin: 0 1%;
		margin-bottom: 12px;
	}
  .videoList{
    height: auto;
  }
  .videoList ul li div{
    height: 200px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/video/video.vue